// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Data indkøbscenter",
        "pull_refresh": "Træk ned for at opdatere",
        "release_refresh": "Slip for at opdatere",
        "refresh_loading": "Indlæser ...",
        "footer_text": "Tjenester leveret af Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Søgeland/region",
        "my_flow": "Mine data",
        "charge_code": "Voucher -kode",
        "coupons": "Kuponer",
        "local_package": "Lokale data",
        "more": "Mere",
        "popular_destination": "Land/region",
        "buy_now": "Køb nu",
        "package_useing": "Aktiv",
        "unused": "Inaktiv",
        "download_app": "Download app",
        "enter_the_mall_list": "Gå til indkøbscenterlisten",
        "no_data": "Ingen data endnu",
        "no_data_available": "Ingen data tilgængelige",
        "copy_success": "Kopieret",
        "copy_fail": "Kopiering mislykkedes",
        "meritsTitle": "Hvad er fordelerne?",
        "merits1": "Ingen SIM påkrævet & Ingen månedlige gebyrer",
        "merits2": "Integreret med de top 2-3 operatører til automatisk netværksbytte",
        "go_buy": "Købe",
        "instant_savings": "Spar",
        "expires_in": "Udløber om",
        "download_app_tips": "Download appen for flere tilbud og oplevelser"
    },
    "packages": {
        "sub_title": {
            "us": "Ekskluderet Guam, Saipan",
            "it": "Inklusive Vatikanstaten, San Marino",
            "va": "Inklusive Italien, San Marino",
            "sm": "Inklusive Italien, Vatikanstaten",
            "ma": "Inklusive Western Sahara",
            "eh": "Inklusive Marokko",
            "ch": "Inklusive Liechtenstein",
            "li": "Inklusive Schweiz",
            "fr": "Kansallisarvoineen Monacolla",
            "mc": "Inklusive Frankrig",
            "fi": "Inklusive Aland Islands",
            "ax": "Inklusive Finland",
            "gu": "Inklusive Guam",
            "mp": "Inklusive Guam"
        },
        "unlimited_packages": "Ubegrænset datapakke",
        "normal_packages": "Normal datapakke",
        "multi_region_packages": "Multi-region",
        "regional_data": "Regionale data",
        "high_speed_text": "Data med høj hastighed",
        "infiniteFlow": "Ubegrænsede data",
        "unLimitData": "Ubegrænset",
        "high_speed_text_year": "Høj hastighed/MP",
        "package_list": "Pakkeliste",
        "special_offer": "Tilbud",
        "first_month": "1. Måned",
        "periodUnit": {
            "day": "dag",
            "month": "måned",
            "hour": "time",
            "year": "år"
        },
        "periodUnits": {
            "day": "dag",
            "month": "måneder",
            "hour": "time",
            "year": "år"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "for",
            "hour": "h",
            "year": "yr"
        },
        "periodUnitMonthly":"Månedlig",
        "periodUnitsSimp": {
            "day": "d",
            "month": "for",
            "hour": "h",
            "year": "yr"
        },
        "unlimited_good_name": {
            "day": "Day Pass",
            "month": "Månedligt pas",
            "year": "Årligt pas"
        },
        "continuousMonth": "Kontinuerlige måneder",
        "continuousDay": "Kontinuerlige dage",
        "continuousYear": "Kontinuerlige år",
        "day_invalid": "Udløber den aktuelle dag",
        "month_invalid": "Udløber i den aktuelle måned",
        "immediate_valid": "Effektiv straks",
        "tomorrow_day_valid": "Effektiv fra næste dag",
        "tomorrow_month_valid": "Effektiv fra næste måned",
        "detail": {
            "cell_flow": "Data",
            "cell_period": "Gyldighed",
            "buy_quantity": "Beløb",
            "use_area": "Dækning",
            "use_intro": "Vilkår og betingelser",
            "buy_btn": "Bestille",
            "pay": "Betaling",
            "buy_tips": "Du har %@packageName-pakket i brug. Vil du købe dette pakket?",
            "haveOrderTips": "Ordre med ventende betaling oprettet. Klik Bekræft for at gå til min dataside！"
        },
        "confirm": {
            "title": "Ordrebekræftelse",
            "real_pay_amount": "Betalt beløb",
            "online_payment": "Online betaling",
            "create_order_error": "Opsætningen mislykkedes"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Få ordrestatus ...",
            "buy_success": "Bestil komplet",
            "buy_pending": "Afventende bekræftelse",
            "buy_pending_tip": "Betal i processen ... Hvis betaling ikke overføres inden for 10 minutter, bedes du kontakte os for støtte.",
            "get_payment_info_fail": "Erhvervelse af betalingsinfo mislykkedes",
            "cell_package": "Pakke",
            "cell_buy_amount": "Subtotal",
            "cell_real_amount": "Betalt beløb",
            "go_to_order_btn": "Gå til min pakke",
            "back_home": "Tilbage til hjemmet",
            "back_mall": "Tilbage til indkøbscenter",
            "ordersn_empty": "Bestil Sn kan ikke være tom",
            "order_search_error": "Uventet fejl",
            "goodsName":"Produktnavn"
        },
        "fail": {
            "payment_fail": "Betaling mislykkedes",
            "back_home": "Tilbage til hjemmet"
        }
    },
    "CountryGroup": {
        "title": "Land/region",
        "placeholder": "Søgeland eller region",
        "clear": "Klar",
        "history": "Søghistorik"
    },
    "PromotionCode": {
        "verification": {
            "title": "Voucher -kode",
            "minititle": "Voucher -kode",
            "input": "Indtast venligst top-up-koden",
            "explain": "TIPS: Tryk på scanningsknappen øverst til højre for at scanne QR -koden på voucher -kortet, eller indtast manuelt voucher -koden (store og små bogstaver), hvis den ikke fungerer.",
            "submit": "Indsende",
            "exchange": "Indløs",
            "cancel": "Ophæve",
            "Inquiry": "Er du sikker på at udveksle",
            "ErrorCode": "Genoplad kodefejl"
        },
        "recharge_success": {
            "package": "Pakke",
            "content": "Med succes indløses",
            "back": "Tilbage til indkøbscenter",
            "view_packets": "Gå til min pakke"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktiveret",
            "isFirst": "Prioriteret",
            "toFirst": "Indstille prioritet",
            "inactive": "Inaktiveret"
        },
        "periodUnits": {
            "minute": "minut",
            "hour": "time",
            "day": "dag",
            "month": "måneder"
        },
        "useIntro": {
            "tip1": "Ubegrænset datapakke har højere prioritet end volumendatapakke.",
            "tip2": "Brugsprioriteten vil være baseret på købsdato for den samme type pakke, dvs. pakken med den tidligste købsdato vil først blive brugt op, mens prioriteringen af enkeltregionspakker er højere end regional pakke.",
            "tip3": "Du kan også manuelt justere prioriteten ved at bruge pakker af samme type."
        },
        "myFlow": "Mine data",
        "remainingFlow": "Data tilbage",
        "remainingTime": "Gyldig venstre",
        "remainingHighFlow": "Højhastighedsdata tilbage",
        "validPeriod": "Gyldighed",
        "noneFlow": "Ingen datapakke",
        "noneFlowTip": "Køb venligst datapakken og nyd netværket af høj kvalitet",
        "buyPackFlow": "Købe pakker",
        "checkInvalidFlow": "Kontroller udløbet datapakke",
        "orderList":  {
            "title": "mine ordrer",
            "amount_paid": "Total",
            "device": "Ejet enhed",
            "order_details": "Bestil detaljer",
            "total_amont": "Subtotal",
            "orderSN": "Bestillingsnr.",
            "createTime": "Oprettelsestid",
            "cancelTime": "Lukket tid",
            "payTime": "Bestil tid",
            "unsubTime": "Aflyst tid",
            "payMethod": "Betalingsmetode",
            "thirdSN": "Transaktionsnr.",
            "delete": "Slet",
            "cancel": "Annuller ordre",
            "unsub": "Tilbagebetale",
            "goto_cancel": "Vil du annullere ordren?",
            "goto_unsubscribe": "Vil du afmelde ordren?",
            "delete_Tips": "Ordren kan ikke genoptages efter at være blevet slettet, derfor kan dine efterbehandlingsproblemer ikke håndteres.Er du sikker på at du vil slette den?",
            "status_success": "Afsluttet",
            "status_pending": "Ubetalt",
            "status_cancel": "Lukket",
            "status_unsub": "Annulleret",
            "payMethod_stripe": "Kreditkort"
          },
    },
    "registerlogin": {
        "create_account_tip":"Opret en konto, start eksklusiv oplevelse",
        "select_country_tip":"Enhedsanvendelse af land/region",
        "email_name": "Post",
        "phone_name": "Telefon",
        "email_address": "E -mail -adresse",
        "password": "adgangskode",
        "country": "land",
        "select_country": "Vælg et land",
        "cancel": "Ophæve",
        "confirm": "Sikker",
        "please_enter": "Indtast 6-20 tegn (kombination af bogstaver, tal eller symboler)",
        "select_country_tips": "Landvalg er til at se lokale pakker. Det kan ikke ændres efter registrering. Bekræft venligst!",
        "global_roaming": "International domænekode",
        "phone_number": "telefonnummer",
        "agree": "enig",
        "user_agreement": "Brugeraftale",
        "and": "og",
        "privacy_policy": "Privatlivspolitik",
        "register_login": "Tilmeld dig eller log ind",
        "login_error": "Antallet af login er for hyppigt, prøv igen senere!",
        "register_error": "Antallet af registreringer er for hyppigt, prøv igen senere!",
        "forgot_pwd": "Glem adgangskoden",
        "app_tips": "Log ind på appen med denne konto efter at have downloadet den for at få adgang til flere funktioner.",
        "download_app": "Gå for at downloade appen",
        "rememberPwd": "Husk adgangskode",
        "third_login": "Fortsæt med",
        "agreement_tips": "Kontroller, at brugeraftalen og fortrolighedspolitikken",
        "selectCountry_tips": "Bemærk venligst, at det registrerede land direkte vil påvirke følgende betalingsmetoder og valutaer, vælg venligst efter dit behov.",
        "login_error_cancel": "Brugeren annullerede logind",
        "login_error_auth": "Tillad pop-ups fra browserindstillingerne",
        "device_tips": "Enhed venter på aktivering. Behandles inden for 24 timer."
    },
    "forgotPwd": {
        "forgot_pwd": "Glem adgangskoden",
        "email_address": "E -mail -adresse",
        "next": "Næste",
        "email_has_been_sent": "Vi har sendt en e -mail til %@email. Klik på linket og følg trinnene for at hente din adgangskode.",
        "have_retrieved_it": "Jeg har fundet det",
        "unable_to_receive_email": "Kan du ikke modtage e -mailen? Kontroller, om der er e -mails fra %@email under din spam og slettede mail -bibliotek",
        "or": "eller",
        "resend": "Send igen",
        "global_roaming": "International domænekode",
        "phone_number": "telefonnummer",
        "verification_code_has_been_sent": "Vi har sendt bekræftelseskoden til:",
        "verification_code": "Bekræftelseskode",
        "no_verification_code_received": "Har du ikke modtaget bekræftelseskoden?",
        "please_enter": "Indtast 6-20 tegn (kombination af bogstaver, tal eller symboler)",
        "reset_password": "Nulstil adgangskode",
        "reset_successful": "Nulstil med succes"
    },
    "coupons": {
        "coupons_name": "Kuponer",
        "no_coupons": "Ingen kuponer endnu",
        "no_data": "Ingen data endnu",
        "applicable_to_the_following": "Kuponer er egnede til følgende datapakke"
    },
    "digital":{
        "title":"Enhed SN",
        "purchased":"Mine køb",
        "viewAll":"Mere",
        "skinStore":"Produktbutik",
        "completed":"Købt",
        "goBuy":"Købe",
        "order": {
          "title":"Købte ordrer"
        },
        "detail": {
          "describe":"Beskrivelse"
        }
    },
    "viewPL": {
        "other": 'andre'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "Inaktiveret",
            "IN_USING": "Tilgængelig",
            "USE_END": "Udmattet",
            "EXPIRE": "Udløbet",
            "TRANSFER": "Overførsel",
            "UNSUBSCRIBE": "Ophæve",
            "VALID": "Gyldig",
            "INVALID": "Ugyldig",
            "EXCHANGE_POINTS": "Indløs point"
        },
        "noneFlow": "Ingen udløbet datapakke",
        "pageName": "Udløbet datapakke"
    },
    "flowDetail": {
        "title": "Dataoplysninger",
        "flow": "Data",
        "validTime": "Gyldig starter",
        "invalidTime": "Gyldig indtil",
        "coverage": "Dækning",
        "useIntro": "Vilkår og betingelser",
        "purchaseTime": "Købt kl",
        "subtotal": "Subtotal",
        "status": "Status",
        "cancel": "Ophæve",
        "buyAgain": "Køb det igen",
        "validity": "Gyldighed",
        "tip": "Meddelelse",
        "cancelTip": "Er du sikker på, at du vil tilbagebetale denne pakke?",
        "dataLeft": "Data tilbage"
    },
    "netError": {
        "try_again": "Prøv igen",
        "net_error": "Intet netværk",
        "try_again_desc": "Kontroller venligst netværksindstillingen, og prøv igen"
    },
    "loadFail": {
        "try_again": "Prøv igen",
        "load_fail": "Indlæsning mislykkedes",
        "load_fail_desc": "Dataindlæsning mislykkedes, prøv igen",
        "IMEI_Not_Exist": "IMEI ikke eksisterer, prøv å komme inn fra høyre inngang",
        "Project_Not_Exist": "En fejl opstår. Kontakt kundeservice. (01)",
        "commonError": "En fejl opstår. Kontakt kundeservice."
    },
    "settlement_Easy_and_convenient": "Let og praktisk",
    "settlement_Great_deal": "Meget",
    "settlement_Safe_and_secure": "Sikker og sikker",
    "settlement_Autopay_service_regulation": "Regulering af autopay -service",
    "settlement_Read": "Læse",
    "settlement_No_coupon": "Ingen tilgængelig kupon",
    "settlement_Subtotal": "Subtotal",
    "settlement_Coupon": "Kupon",
    "settlement_TOTAL": "Total",
    "settlement_promotion_tip": "Det salgsfremmende tilbud kan ikke bruges sammen med nogen kuponer",
    "settlement_coupon_tip": "Kuponen kan ikke bruges i forbindelse med andre salgsfremmende tilbud",
    "member_myFlow_noList": "Ingen data",
    "detail_se_content": "En sikker, let og praktisk måde. Du kan til enhver tid afmelde",
    "Enter_Promo_code": "Fremmende kode",
    "Enter_Promo_Coupon": "Kuponer",
    "settlement_Not_used_coupon": "Kupon ikke brugt",
    "settlement_Available_coupon": "Tilgængelig",
    "settlement_Unavailable_coupon": "Utilgængelig",
    "please_Enter_Promo_code": "Indtast promoveringskoden",
    "please_Select_Coupon_use": "Vælg den kupon, du vil bruge.",
    "Buy_Now": "Køb nu",
    "Dont_Use_Any": "Brug ikke noget",
    "settlement_confirm": "Bekræfte",
    "settlement_tips": "Bekræfte",
    "flowDetail_unsubscribe": "Afmeld",
    "flowDetail_unsubscribed": "Afmeldt",
    "flowDetail_isCancelPackage": "Afmeld denne pakke?",
    "flowDetail_confirmAgreementUnsubscribe": "Du kan ikke have den gode aftale efter afmelding. Er du sikker på, at du vil afmelde dig?",
    "flowDetail_cancel": "Ophæve",
    "flowDetail_cancelSuccess": "Afmeld dig med succes",
    "packages_detail_promotion": "Forfremmelse",
    "orderTips":{
        "iDay" : "dag",
        "iDays" : "dage",
        "iMonth" : "måned",
        "iMonths" : "måneder",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol På dit første køb, Betal %@money/%@periodSymbol senere, Du kan til enhver tid afmelde",
        'Monthly_discount':"Gem %@saveMoney hver %@period! Du kan til enhver tid afmelde",
        'Ordinary_monthly_package':"En sikker, let og praktisk måde. Du kan til enhver tid afmelde",
        "AlreadyPurchased":'Beklager, at du kun kan abonnere på en datapakke i øjeblikket. Afmeld dig af “%@” og abonner senere på enhver pakke, du ønsker, efter at den udløber.',
        "Contract_recommendation_First":'<label>Med autopay -service, på dit første køb, skal du kun betale</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Du kan til enhver tid afmelde'
        +'<a class="btn">Abonner ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Med autopay -service skal du kun betale</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Du kan til enhver tid afmelde'
        +'<a class="btn">Abonner ></a></p>',
        "Contract_recommendation_General":"<label>Med autopay -service</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">En sikker, let og praktisk måde. Du kan til enhver tid afmelde'
        +'<a href="javascript:;" class="btn">Abonner ></a></p>',
        'BanlanceDoubleCheck':'Er du sikker på, at du vil betale med balance?',
    },
    feedback: {
        title: "feedback",
        placeholder: "Indtast venligst det land, du ønsker at besøge eller andre spørgsmål, så imødekommer vi dine behov så hurtigt som muligt!",
        submit: "Indsend",
        submit_success: "Indsendt med succes",
        other_opinions: "Andre meninger"
    },
    view_country_input: 'Indtast venligst din konto',
    "select_package": {
        "title": "Vælg Data",
        "allPackage": 'Alle Data',
        "type": "Type",
        "flow": "Data",
        "month_package": "Månedsplan",
        "flow_package": "Datapakke",
        "time": "Varighed",
        "period": "Cykel",
        "auto_debit": "Auto-Aftræk Info",
        "auto_subscribe": "Auto-Forlængelse",
        "detail": "Data Detaljer",
        "carrier": "Understøttede Operatører",
        "country": "Dækkede Lande",
        "notice": "Købsguide"
    }
}